import type { Injection } from '../../../types/utils';
import type { TabsInjection } from './models';

export const TABS_INJECTION: Injection<TabsInjection> = Object.freeze({
  key: Symbol('TABS_INJECTION_KEY'),
});
